import { useEffect, useRef, useState } from 'react';
import { config } from '@/config';

const PING_INTERVAL_MS = 20_000;
const PING_TIMEOUT_MS = 4_000;
const FAILURES_BEFORE_DOWN = 2;

export function useBackendHealth(): { isDown: boolean } {
    const [isDown, setIsDown] = useState(false);
    const failuresRef = useRef(0);

    useEffect(() => {
        let cancelled = false;

        const ping = async () => {
            const controller = new AbortController();
            const timeoutId = window.setTimeout(() => controller.abort(), PING_TIMEOUT_MS);
            try {
                const res = await fetch(`${config.apiUrl}/health`, {
                    method: 'GET',
                    signal: controller.signal,
                    cache: 'no-store',
                });
                if (cancelled) return;
                if (res.ok) {
                    failuresRef.current = 0;
                    setIsDown(false);
                } else {
                    failuresRef.current += 1;
                    if (failuresRef.current >= FAILURES_BEFORE_DOWN) setIsDown(true);
                }
            } catch {
                if (cancelled) return;
                failuresRef.current += 1;
                if (failuresRef.current >= FAILURES_BEFORE_DOWN) setIsDown(true);
            } finally {
                window.clearTimeout(timeoutId);
            }
        };

        ping();
        const intervalId = window.setInterval(ping, PING_INTERVAL_MS);

        return () => {
            cancelled = true;
            window.clearInterval(intervalId);
        };
    }, []);

    return { isDown };
}
